exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-presence-jsx": () => import("./../../../src/pages/presence.jsx" /* webpackChunkName: "component---src-pages-presence-jsx" */),
  "component---src-pages-species-jsx": () => import("./../../../src/pages/species.jsx" /* webpackChunkName: "component---src-pages-species-jsx" */),
  "component---src-pages-species-species-id-jsx": () => import("./../../../src/pages/species/[speciesID].jsx" /* webpackChunkName: "component---src-pages-species-species-id-jsx" */)
}

